import http from './http'

export default {
  statistics: {
    getBillSalesSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillsalessummarypagelist', {
        shopId: search.shop,
        productClassId: search.productClass,
        keyword: search.keyword,
        orderByMoney: search.orderByMoney,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillSalesSummaryByProductClassPageList (search, pageConfig) {
      return http.get('/statistics/getbillsalessummarybyproductclasspagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        grade: search.grade,
        shopId: search.shop,
        orderByMoney: search.orderByMoney,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillPaymentsSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillpaymentssummarypagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        merchantId: search.merchantId,
        type: search.type,
        shopId: search.shop,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillPaymentsByDeviceSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillpaymentsbydevicesummarypagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        merchantId: search.merchantId,
        shopId: search.shop,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillSalesByMerchantSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillsalesbymerchantsummarypagelist', {
        shopId: search.shop,
        merchantId: search.merchantId,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMemberCardMoneyAndOperateRecordsSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getmembercardmoneyandoperaterecordssummarypagelist', {
        shopId: search.shop,
        memberCardClass: search.memberCardClass,
        memberLevel: search.memberLevel,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillPaymentMoneyAndCountByDaySummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillpaymentmoneyandcountbydaysummarypagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        shopId: search.shopId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillPaymentTypeMoneyAndCountByShopSummaryPageList (search, pageConfig) {
      return http.get('/statistics/getbillpaymenttypemoneyandcountbyshopsummarypagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        shopId: search.shopId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillPaymentMoneyAndCountByHourSummaryList (search) {
      return http.get('/statistics/getbillpaymentmoneyandcountbyhoursummarylist', {
        date: search.date,
        shopId: search.shopId
      })
    },
    getDayReportByShopPageList (search, pageConfig) {
      return http.get('/statistics/getdayreportbyshoppagelist', {
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMemberExpenseSummaryByMerchantPageList (search, pageConfig) {
      return http.get('/statistics/getmemberexpensesummarybymerchantpagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        // date: search.date,
        shopId: search.shop,
        merchantId: search.merchantId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMemberExpenseSummaryByDatePageList (search, pageConfig) {
      return http.get('/statistics/getmemberexpensesummarybydatepagelist', {
        startDate: search.startDate,
        endDate: search.endDate,
        // date: search.date,
        shopId: search.shop,
        merchantId: search.merchantId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getProductAccessSalePageList (search, pageConfig) {
      return http.get('/statistics/getProductAccessSalePageList', {
        shopId: search.shop,
        keyword: search.keyword,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize,
        merchantId: search.merchantId
      })
    }
  },
  homePage: {
    getBillPaymentMoneyAndCount (shopIds) {
      return http.get('/statistics/homePage/getbillpaymentmoneyandcount', { shopIds: shopIds })
    },
    getMemberCardSendCount (shopIds) {
      return http.get('/statistics/homePage/getmembercardsendcount', { shopIds: shopIds })
    },
    getMemberExpenseAndRecharge (shopIds) {
      return http.get('/statistics/homePage/getmemberexpenseandrecharge', { shopIds: shopIds })
    },
    getBillPaymentMoneyAndCountByHourSummaryList (shopIds) {
      return http.get('/statistics/homePage/getbillpaymentmoneyandcountbyhoursummarylist', { shopIds: shopIds })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/statistics.js